// extracted by mini-css-extract-plugin
module.exports = {"resultlWidgetWrapper":"ptaVN","source":"NQDaT","cs":"cHLBk","cl":"B9dc2","noteText":"nu5FH","vsBox":"iSkDN"};